import { useTranslation } from "react-i18next";

export default function TechAreaSearch({ onChange, searchObject }) {
  let { t } = useTranslation();
  return (
    <ul className="list-inline mt-2">
      <li className="list-inline-item">
        <div className="form-group">
          <input
            placeholder={t("Tech Area Name")}
            className="form-control"
            type="text"
            value={searchObject.description}
            onChange={onChange}
            name="description"
          />
        </div>
      </li>
    </ul>
  );
}
